import React from 'react';

interface MONIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

export const MONIcon: React.FC<MONIconProps> = ({
  width = 32,
  height = 32,
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="#240057"
      />
      <path
        d="M31.75 16C31.75 24.6985 24.6985 31.75 16 31.75C7.30152 31.75 0.25 24.6985 0.25 16C0.25 7.30152 7.30152 0.25 16 0.25C24.6985 0.25 31.75 7.30152 31.75 16Z"
        stroke="white"
        strokeOpacity="0.3"
        strokeWidth="0.5"
      />
      <path
        d="M16.0005 2.96045C12.2534 2.96045 3.02539 12.2346 3.02539 15.9999C3.02539 19.7653 12.2541 29.0401 16.0005 29.0401C19.7469 29.0401 28.9762 19.766 28.9762 15.9999C28.9762 12.2339 19.7475 2.96045 16.0005 2.96045ZM13.9784 23.4561C12.3985 23.0235 8.15033 15.5558 8.58091 13.9677C9.01149 12.3797 16.4426 8.11048 18.0225 8.54309C19.6024 8.97571 23.8506 16.4434 23.42 18.0315C22.9895 19.6195 15.5584 23.8887 13.9784 23.4561Z"
        fill="white"
      />
    </svg>
  );
};

export default MONIcon;
